<template>
  <div class="wrapper pt-4 mt-6">
    <div class="page-wrapper">
      <ResultsSearch class="mt-5" :ranges="ranges" />
    </div>
    <div v-if="gymApiStatus === 'LOADED'">
      <div v-if="numOfGyms !== undefined">
        <div v-if="numOfGyms">
          <GymResults />
          <div class="m-a max-w50">
            <Pagination />
          </div>
        </div>
        <div v-else>
          <NoGymsFound />
        </div>
      </div>
    </div>
    <div
      class="container has-text-centered"
      v-else-if="gymApiStatus === 'LOADING'"
    >
      <PulseLoader
        :loading="gymApiStatus === 'LOADING'"
        color="#00c5fd"
        height="100%"
        width="100%"
      />
    </div>

    <transition name="slide-left">
      <Sidebar v-if="filterSidebar" />
    </transition>
  </div>
</template>

<script>
import GymResults from "@/components/organisms/GymResults.vue";
import Pagination from "@/components/molecules/Pagination.vue";
import ResultsSearch from "@/components/molecules/ResultsSearch.vue";
import NoGymsFound from "@/components/atoms/NoGymsFound.vue";
import Sidebar from "@/components/molecules/Sidebar.vue";
import PulseLoader from "vue-spinner/src/PulseLoader";
import { mapState } from "vuex";
export default {
  data() {
    return {
      ranges: [1, 5, 10],
    };
  },
  components: {
    GymResults,
    ResultsSearch,
    Pagination,
    NoGymsFound,
    Sidebar,
    PulseLoader,
  },
  computed: {
    ...mapState([
      "search_value",
      "selected_range",
      "filterSidebar",
      "gymApiStatus",
      "numOfGyms"
    ]),
  },
};
</script>

<style scoped>
.results-found-text {
  margin-left: 5%;
}

.slide-left-enter-active {
  transition: all 0.4s cubic-bezier(0, 0, 0.2, 1);
}

.slide-left-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 1, 1);
}

.slide-left-enter,
.slide-left-leave-to {
  transform: translateX(-100vw);
}

.sticky-notif {
  position: sticky;
  z-index: 150;
  text-align: center;
}

.max-w50 {
  max-width: 50%;
}
</style>
